var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card margin-bottom-m"},[_c('ul',_vm._l((_vm.foods),function(item){return _c('li',{key:item.food_id},[_vm._v(_vm._s(item.food_name)+" ("+_vm._s(item.amount)+" g.)")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd120ae6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/brand/health/components/nutritionPlan/MealCard.vue
// module id = null
// module chunks = 